// Central category metadata. `path` is the listing route; `type` is the backend content type.
export const CATEGORIES = [
  {
    type: "katha",
    path: "/kathas",
    deva: "कथा",
    en: "Kathas",
    en_hi: "कथाएँ",
    tagline_en: "Stories and narratives from India's vast spiritual and scriptural traditions.",
    tagline_hi: "भारत की विशाल आध्यात्मिक एवं शास्त्रीय परंपराओं की कथाएँ।",
    cta_en: "Explore Kathas",
    cta_hi: "कथाएँ देखें",
    icon: "BookOpen",
    image: "https://images.unsplash.com/photo-1651466993062-ecfe95a907b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    type: "mantra",
    path: "/mantras",
    deva: "मंत्र",
    en: "Mantras",
    en_hi: "मंत्र",
    tagline_en: "Mantras with Devanagari text, transliteration, pronunciation guidance, meaning and context.",
    tagline_hi: "देवनागरी पाठ, लिप्यंतरण, उच्चारण, अर्थ एवं संदर्भ सहित मंत्र।",
    cta_en: "Explore Mantras",
    cta_hi: "मंत्र देखें",
    icon: "AudioLines",
    image: "https://images.unsplash.com/photo-1557062975-92aa401cee64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    type: "sukta",
    path: "/suktas",
    deva: "सूक्त",
    en: "Suktas",
    en_hi: "सूक्त",
    tagline_en: "Vedic hymns (suktas) and Vedic knowledge in full, with Devanagari text, transliteration and meaning.",
    tagline_hi: "पूर्ण वैदिक सूक्त एवं वैदिक ज्ञान — देवनागरी पाठ, लिप्यंतरण एवं अर्थ सहित।",
    cta_en: "Explore Suktas",
    cta_hi: "सूक्त देखें",
    icon: "ScrollText",
    image: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/c332f168c204d952d0c6a6d2c551fccd0291a78361a35f6ba15f0ef48a89b469.jpeg",
  },
  {
    type: "puja_vidhi",
    path: "/rituals",
    deva: "पूजा विधि",
    en: "Rituals & Pooja Guides",
    en_hi: "पूजा विधि",
    tagline_en: "Step-by-step guides for commonly performed poojas, rituals and observances.",
    tagline_hi: "सामान्यतः की जाने वाली पूजा, अनुष्ठान एवं व्रतों की चरण-दर-चरण मार्गदर्शिका।",
    cta_en: "Explore Pooja Vidhi",
    cta_hi: "पूजा विधि देखें",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1641296834354-a0deed5244fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    type: "stotra",
    path: "/stotras",
    deva: "स्तोत्र",
    en: "Stotras",
    en_hi: "स्तोत्र",
    tagline_en: "Traditional hymns, prayers and devotional compositions with meanings and explanations.",
    tagline_hi: "अर्थ एवं व्याख्या सहित परंपरागत स्तोत्र, स्तुतियाँ एवं भक्ति रचनाएँ।",
    cta_en: "Explore Stotras",
    cta_hi: "स्तोत्र देखें",
    icon: "Music4",
    image: "https://images.unsplash.com/photo-1557062975-92aa401cee64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    type: "festival",
    path: "/festivals",
    deva: "पर्व एवं उत्सव",
    en: "Festivals & Observances",
    en_hi: "पर्व एवं उत्सव",
    tagline_en: "Understand the significance, traditions and practices of important festivals and observances.",
    tagline_hi: "प्रमुख पर्वों एवं व्रतों का महत्व, परंपराएँ एवं प्रथाएँ समझें।",
    cta_en: "Explore Festivals",
    cta_hi: "पर्व देखें",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1709241394789-c6d55d9601e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    type: "grantha",
    path: "/granthas",
    deva: "ग्रंथ",
    en: "Sacred Scriptures",
    en_hi: "ग्रंथ",
    tagline_en: "Complete scriptures with chapters — Sanskrit verses, transliteration, meaning, context, benefits and purpose (Durga Saptashati, Sri Rudram, Bhagavad Gita and more).",
    tagline_hi: "अध्याय-सहित पूर्ण ग्रंथ — संस्कृत श्लोक, लिप्यंतरण, अर्थ, संदर्भ, लाभ एवं प्रयोजन (दुर्गा सप्तशती, श्री रुद्रम्, भगवद्गीता आदि)।",
    cta_en: "Explore Scriptures",
    cta_hi: "ग्रंथ देखें",
    icon: "ScrollText",
    image: "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/c332f168c204d952d0c6a6d2c551fccd0291a78361a35f6ba15f0ef48a89b469.jpeg",
  },
];

export const CATEGORY_BY_TYPE = CATEGORIES.reduce((acc, c) => {
  acc[c.type] = c;
  return acc;
}, {});

// Bookable service categories (Pooja, Homam, Yagya, Astrology, Numerology, Vastu, Panchangam, Muhurta).
export const SERVICE_CATEGORIES = [
  { kind: "pooja", deva: "पूजा", en: "Pooja", form: "venue", icon: "Flame",
    desc_en: "Traditional poojas performed at your home or venue.", desc_hi: "आपके घर या स्थान पर संपन्न परंपरागत पूजाएँ।",
    image: "https://images.unsplash.com/photo-1641296834354-a0deed5244fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "homam", deva: "हवन / होम", en: "Homam", form: "venue", icon: "Flame",
    desc_en: "Sacred fire rituals (homam) for various observances.", desc_hi: "विविध अवसरों हेतु पवित्र अग्नि अनुष्ठान (होम)।",
    image: "https://images.unsplash.com/photo-1641296834354-a0deed5244fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "yagya", deva: "यज्ञ", en: "Yagya", form: "venue", icon: "Sparkles",
    desc_en: "Traditional yagyas conducted with care and shastra.", desc_hi: "शास्त्रसम्मत रूप से संपन्न परंपरागत यज्ञ।",
    image: "https://images.unsplash.com/photo-1557062975-92aa401cee64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "astrology", deva: "ज्योतिष", en: "Jyotisha", form: "consult", icon: "Star",
    desc_en: "Jyotisha consultations based on your birth details.", desc_hi: "जन्म विवरण पर आधारित ज्योतिष परामर्श।",
    image: "https://images.unsplash.com/photo-1557062975-92aa401cee64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "numerology", deva: "अंक ज्योतिष", en: "Numerology", form: "consult", icon: "Calculator",
    desc_en: "Numerology readings from your name and date of birth.", desc_hi: "नाम एवं जन्मतिथि से अंक ज्योतिष विश्लेषण।",
    image: "https://images.unsplash.com/photo-1651466993062-ecfe95a907b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "vastu", deva: "वास्तु", en: "Vastu", form: "consult", icon: "Home",
    desc_en: "Vastu guidance for homes and workplaces.", desc_hi: "घर एवं कार्यस्थल हेतु वास्तु मार्गदर्शन।",
    image: "https://images.unsplash.com/photo-1557062975-92aa401cee64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "panchang", deva: "पंचांग", en: "Panchangam", form: "consult", icon: "CalendarDays",
    desc_en: "Panchangam readings and personalised almanac guidance.", desc_hi: "पंचांग पठन एवं व्यक्तिगत पंचांग मार्गदर्शन।",
    image: "https://images.unsplash.com/photo-1651466993062-ecfe95a907b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { kind: "muhurt", deva: "मुहूर्त", en: "Muhurta", form: "consult", icon: "Clock",
    desc_en: "Selection of an auspicious time (shubh muhurta).", desc_hi: "शुभ मुहूर्त का चयन।",
    image: "https://images.unsplash.com/photo-1641296834354-a0deed5244fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
];

export const SERVICE_BY_KIND = SERVICE_CATEGORIES.reduce((a, c) => {
  a[c.kind] = c;
  return a;
}, {});

export const typeToPath = (type) => (CATEGORY_BY_TYPE[type] ? CATEGORY_BY_TYPE[type].path : "/explore");

// Detail route for an item
export const itemPath = (item) => {
  const cat = CATEGORY_BY_TYPE[item.type];
  const base = cat ? cat.path : "/explore";
  return `${base}/${item.slug}`;
};
